import { Suspense, lazy } from "react";

import Loading from "./components/loading/Loading";
import "./App.css";

// provider
import { UserContextProvider, BikunContextProvider } from "./provider";

const Routing = lazy(() => import("./components/routing/Routing"));

function App() {
  return (
    <UserContextProvider>
      <BikunContextProvider>
        <Suspense fallback={<Loading />}>
          <Routing />
        </Suspense>
      </BikunContextProvider>
    </UserContextProvider>
  );
}

export default App;
